import store from "@store/index";
import func from "@uikit/func";
import { getIt } from "@uikit/getIt";
import { FotAuthStore } from "imagica-corekit/dist/base/store/FotAuthStore";

const authStore = getIt(FotAuthStore);

export class CreatorUtil {
  static getVariableList(currentSourceNodeValue: any) {
    const brainAuthToken = authStore.state.brainToken;
    return [
      {
        name: "currentSourceNodeValue",
        node: {
          data: {
            textAreaValue: currentSourceNodeValue,
          },
        },
      },
      {
        name: "brainAuthToken",
        node: {
          data: {
            textAreaValue: brainAuthToken,
          },
        },
      },
      ...store.getState().fot.variableList,
    ];
  }

  static evaluateFinalBodyStr(currentSourceNodeValue: any, bodyParam: any) {
    if (func.isEmpty(bodyParam)) {
      return "";
    }
    // 注入currentSourceNodeValue
    const variableList = CreatorUtil.getVariableList(currentSourceNodeValue);

    // 替换body变量
    // bodyParam can either be a string or object, if JSON.parse(bodyParam) works then it's an object otherwise string
    let bodyStr = bodyParam;
    if (typeof bodyParam === "object") {
      bodyStr = JSON.stringify(bodyParam);
    }
    // trim is moved here as part of post processing
    bodyStr = bodyStr.trim();
    const varFormatReg = /\${\w+\}/g;
    variableList.forEach(y => {
      const varReg = new RegExp(`\\\$\\\{${y.name}\\\}`, "g");
      bodyStr = bodyStr && bodyStr.replace(varReg, y.node.data.textAreaValue);
    });
    // 将剩下的没有的变量全部替换为空字符串
    bodyStr =
      bodyStr &&
      bodyStr
        .replace(varFormatReg, "")
        .replace(/\n/g, "")
        .replace(/(\r\n|\n|\r)/g, "")
        .replace(/^"/, "")
        .replace(/"$/, "");
    return bodyStr;
  }
}
